import { createAction } from '@saucelabs/sl-util-redux';

import * as types from './types';

export const cleanup = createAction(types.CLEANUP);
export const toggleBuildCard = createAction(types.TOGGLE_BUILD_CARD);
export const changeTab = createAction(types.CHANGE_TAB);
export const loadInitialDataRequest = createAction(types.LOAD_INITIAL_DATA.REQUEST);
export const loadInitialDataSuccess = createAction(types.LOAD_INITIAL_DATA.SUCCESS);
export const loadInitialDataFailure = createAction(types.LOAD_INITIAL_DATA.FAILURE);
